import { render, staticRenderFns } from "./InstructorInstructions.vue?vue&type=template&id=44a8e715&scoped=true&"
import script from "./InstructorInstructions.vue?vue&type=script&lang=js&"
export * from "./InstructorInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a8e715",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
